import React from 'react';
import { CHECKOUT_URL } from '../data/content';
import { trackCheckoutClick } from '../utils/pixel';
interface CTAButtonProps {
  label: string;
  variant?: 'primary' | 'light';
  size?: 'lg' | 'md';
  className?: string;
}
export function CTAButton({
  label,
  variant = 'primary',
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center rounded-2xl text-center font-extrabold uppercase tracking-tight leading-tight transition-transform duration-150 active:scale-[0.98] hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-brand text-white shadow-[0_10px_0_0_#0E4CA8] hover:bg-brand-dark hover:shadow-[0_8px_0_0_#0B3C87]',
    light: 'bg-white text-navy border-2 border-navy shadow-[0_8px_0_0_#0B1B3A] hover:bg-cream'
  };
  const sizes = {
    lg: 'px-5 py-4 text-[15px] sm:text-lg sm:px-8 sm:py-5',
    md: 'px-4 py-3.5 text-[13.5px] sm:text-base sm:px-6 sm:py-4'
  };
  return <a href={CHECKOUT_URL} onClick={trackCheckoutClick} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-29" data-mp="198wjv75v3e3j">
      <span className="text-balance" data-id="element-30" data-mp="1db9pzwoite0u">{label}</span>
    </a>;
}